
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_7nfqu_hlf1w_149",
  "has-adaptive-widths-default": "awsui_has-adaptive-widths-default_7nfqu_hlf1w_193",
  "has-adaptive-widths-dashboard": "awsui_has-adaptive-widths-dashboard_7nfqu_hlf1w_198",
  "drawer-expanded-mode": "awsui_drawer-expanded-mode_7nfqu_hlf1w_213",
  "ai-drawer-expanded-mode": "awsui_ai-drawer-expanded-mode_7nfqu_hlf1w_216",
  "bottom-drawer-expanded-mode": "awsui_bottom-drawer-expanded-mode_7nfqu_hlf1w_219",
  "ai-drawer": "awsui_ai-drawer_7nfqu_hlf1w_216",
  "navigation": "awsui_navigation_7nfqu_hlf1w_226",
  "tools": "awsui_tools_7nfqu_hlf1w_227",
  "global-tools": "awsui_global-tools_7nfqu_hlf1w_228",
  "bottom-tool": "awsui_bottom-tool_7nfqu_hlf1w_229",
  "navigation-collapsed": "awsui_navigation-collapsed_7nfqu_hlf1w_278",
  "tools-open": "awsui_tools-open_7nfqu_hlf1w_291",
  "split-panel-side": "awsui_split-panel-side_7nfqu_hlf1w_305",
  "split-panel-bottom": "awsui_split-panel-bottom_7nfqu_hlf1w_312",
  "panel-hidden": "awsui_panel-hidden_7nfqu_hlf1w_325",
  "toolbar-container": "awsui_toolbar-container_7nfqu_hlf1w_335",
  "pseudo-toolbar": "awsui_pseudo-toolbar_7nfqu_hlf1w_349",
  "pseudo-toolbar-content": "awsui_pseudo-toolbar-content_7nfqu_hlf1w_367",
  "notifications-container": "awsui_notifications-container_7nfqu_hlf1w_411",
  "notifications-background": "awsui_notifications-background_7nfqu_hlf1w_415",
  "main-landmark": "awsui_main-landmark_7nfqu_hlf1w_426",
  "main": "awsui_main_7nfqu_hlf1w_426",
  "main-disable-paddings": "awsui_main-disable-paddings_7nfqu_hlf1w_435",
  "content-header": "awsui_content-header_7nfqu_hlf1w_445",
  "content": "awsui_content_7nfqu_hlf1w_445",
  "unfocusable-mobile": "awsui_unfocusable-mobile_7nfqu_hlf1w_455",
  "hidden": "awsui_hidden_7nfqu_hlf1w_460",
  "breadcrumbs-own": "awsui_breadcrumbs-own_7nfqu_hlf1w_464",
  "breadcrumbs-discovered": "awsui_breadcrumbs-discovered_7nfqu_hlf1w_464"
};
  